import React, { Component, useState, useEffect } from 'react';
import { postApi } from '../service/service';
import { API_URL } from '../config';
import { Link } from 'react-router-dom';
import CircularLoader from '../components/common/loader/loader.jsx';
import { getToken } from '../utils/auth';

const JgdSatsangList = ({ match }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [satsangList, setSatsangList] = useState([]);

  let customClass =
      match.path === '/jgd-satsang'
        ? 'satsang'
        : match.path === '/badela-satsang'
        ? 'badela-satsang'
        : match.path === '/prarthna'
        ? 'prarthna'
        : match.path === '/aantarik-prarthna'
        ? 'prarthna'
        : match.path === '/sadhakon-ki-kalam-se'
        ? 'jumbotron'
        : match.path === '/navin-suchnaye'
        ? 'jumbotron'
        : match.path === '/pramukh-antargat-sandesh'
        ? 'jumbotron'
        : match.path === '/jivani'
        ? 'jumbotron'
        : 'jumbotron',
    heading =
      match.path === '/jgd-satsang'
        ? 'सतगुरु जयगुरुदेव:- सत्संग वचन'
        : match.path === '/badela-satsang'
        ? 'सतगुरु जयगुरुदेव:- बड़ेला-धाम सत्संग वचन'
        : match.path === '/prarthna'
        ? 'प्रचलित-प्रार्थनायें'
        : match.path === '/sadhakon-ki-kalam-se'
        ? 'साधकों की कलम से'
        : match.path === '/aantarik-prarthna'
        ? 'बड़ेला-धाम:- आंतरिक प्रार्थना'
        : match.path === '/jivani'
        ? 'जीवन-परिचय'
        : match.path === '/navin-suchnaye'
        ? 'बड़ेला-धाम नवीन सुचनायें एवं सेवा कार्य'
        : match.path === '/pramukh-antargat-sandesh'
        ? 'प्रमुख अन्तर्घट संदेश'
        : match.path === '/badela-dham'
        ? 'बड़ेला-धाम परिचय'
        : match.path === '/nij-anubhav'
        ? 'प्रेमीयो के निज अंतर-अनुभव'
        : match.path === '/jgd-pic'
        ? 'स्वामी जी फोटो-गैलरी'
        : match.path === '/badela-pic'
        ? 'बड़ेला-धाम फोटो-गैलरी'
        : match.path === '/world-message'
        ? 'स्वामी जी महाराज का संदेश-विश्व के समस्त प्रेमियो के लिए'
        : 'स्वामीजी महाराज द्वारा सुनायी गयी कहानियाँ';

  useEffect(() => {
    getSatsangList(`${API_URL}/satsang/list`);
  }, []);

  const getSatsangList = (apiUrl) => {
    const token = getToken();
    let category =
        match.path === '/jgd-satsang'
          ? 1
          : match.path === '/badela-satsang'
          ? 2
          : match.path === '/prarthna'
          ? 3
          : match.path === '/sadhakon-ki-kalam-se'
          ? 14
          : match.path === '/aantarik-prarthna'
          ? 12
          : match.path === '/jivani'
          ? 5
          : match.path === '/navin-suchnaye'
          ? 8
          : match.path === '/pramukh-antargat-sandesh'
          ? 13
          : match.path === '/badela-dham'
          ? 6
          : match.path === '/nij-anubhav'
          ? 7
          : match.path === '/jgd-pic'
          ? 9
          : match.path === '/badela-pic'
          ? 10
          : match.path === '/world-message'
          ? 11
          : match.path === '/kumbh-magh-shakahar'
          ? 15
          : 4,
      header = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body = { category: category };
    postApi(apiUrl, header, body).then((data) => {
      setIsLoading(false);
      if (data.status && data.data) {
        // Filter out deleted items (isDeleted !== true)
        const filteredData = data.data.filter((item) => !item.isDeleted);
        setSatsangList(filteredData);
      } else {
        // If no data or error, set empty list
        setSatsangList([]);
      }
    }).catch((error) => {
      setIsLoading(false);
      // On error, set empty list (don't show error toast for public list endpoint)
      setSatsangList([]);
      console.error('Error loading satsang list:', error.message || error.msg);
    });
  };

  return (
    <div>
      <div style={{ marginBottom: '3%', minHeight: '700px' }}>
        <div className={customClass} style={{ marginBottom: '4%' }}></div>
        {isLoading ? (
          <div className="loader-container">
            <CircularLoader />
          </div>
        ) : (
          <div
            className="main-page-container"
            style={{ position: 'static', width: 'auto' }}
          >
            <h5>{heading}</h5>
            <div style={{ position: 'inherit', width: '90%', height: 'auto' }}>
              <ul className="navbar-nav ml-auto">
                {!isLoading &&
                  (match.path === '/badela-dham'
                    ? satsangList
                        .sort((a, b) => {
                          // Sort by createdAt if available, otherwise by _id (which contains timestamp)
                          let dateA, dateB;
                          if (a.createdAt) {
                            dateA = new Date(a.createdAt);
                          } else {
                            // Extract timestamp from MongoDB ObjectId (first 4 bytes = 8 hex chars)
                            const timestampA = parseInt(a._id.toString().substring(0, 8), 16);
                            dateA = new Date(timestampA * 1000);
                          }
                          if (b.createdAt) {
                            dateB = new Date(b.createdAt);
                          } else {
                            // Extract timestamp from MongoDB ObjectId (first 4 bytes = 8 hex chars)
                            const timestampB = parseInt(b._id.toString().substring(0, 8), 16);
                            dateB = new Date(timestampB * 1000);
                          }
                          return dateA - dateB; // Ascending order (oldest first, newest last)
                        })
                    : satsangList
                  ).map((row) => {
                    if (true) {
                      const route = `${match.path}/${row._id}`;
                      return (
                        <Link className="" to={route} style={{ color: '#1717e6', fontSize: '1.35em' }}>
                          {row.name}
                        </Link>
                      );
                    }
                  })}
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default JgdSatsangList;



// WEBPACK FOOTER //
// ./src/pages/JgdSatsangList.jsx